module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_desktop_04@2x-d4acfe8b489771874ce1ed80a7fec54a.jpg";